import type { Topic } from 'applications/GSP/pages/ParentHelper/types';

export const getDefaultTopicIndex = (chatTopics: Topic[]) =>
  chatTopics.findIndex(topic => !topic.chatId);
